import { styled } from '@mui/material/styles';
import { ListItem } from '@mui/material';

import { renderTypographyStyles } from 'mui/base/utils';
import { ListItemStyles } from '../../../sharedStyles/cardsStyles';

const plusMinus = ({ theme, $plus, $minus }) =>
  $plus || $minus
    ? `
      ${ListItemStyles({ theme, $plus, $minus })};
    
      `
    : null;

const StyledListItem = styled(ListItem)(
  ({ theme, $plus, $minus }) => `
    display: list-item;
    ${renderTypographyStyles(theme.typography.DS_copyMediumRegular)};
    ${plusMinus({ $plus, $minus, theme })};
    p {
       font-size: inherit;
       line-height: inherit;
       margin: ${theme.DS_spacing(['xs'])} 0;
    
      }
  `,
);

export { StyledListItem };
